export default function getWixStylesContextData(wixStyles) {
    return {
        calendarAlignmentWeeklyIsLeft: typeof wixStyles.numbers.calendarAlignmentWeekly === 'undefined'
            ? false
            : wixStyles.numbers.calendarAlignmentWeekly === 0,
        eventTitleFontFamily: typeof wixStyles.fonts.eventTitleFont !== 'undefined'
            ? wixStyles.fonts.eventTitleFont.family
            : 'Arial, Helvetica, sans-serif',
        eventTitleFontSize: typeof wixStyles.fonts.eventTitleFont !== 'undefined'
            ? wixStyles.fonts.eventTitleFont.size
            : 14,
        eventTimeFontSize: typeof wixStyles.fonts.eventTimeFont !== 'undefined'
            ? wixStyles.fonts.eventTimeFont.size
            : 14,
        eventTitleFont: typeof wixStyles.fonts.eventTitleFont !== 'undefined'
            ? wixStyles.fonts.eventTitleFont
            : {},
        hoursTextFont: typeof wixStyles.fonts.hoursTextFont !== 'undefined'
            ? wixStyles.fonts.hoursTextFont
            : {},
        weeklyMonthDayFont: typeof wixStyles.fonts.weeklyMonthDayFont !== 'undefined'
            ? wixStyles.fonts.weeklyMonthDayFont
            : {},
        weekDaysFont: typeof wixStyles.fonts.weekDaysFont !== 'undefined'
            ? wixStyles.fonts.weekDaysFont
            : {},
        eventTimeFont: typeof wixStyles.fonts.eventTimeFont !== 'undefined'
            ? wixStyles.fonts.eventTimeFont
            : {},
        calendarBackgroundColorWithoutOpacity: typeof wixStyles.colors.calendarBackgroundColorWithoutOpacity !==
            'undefined'
            ? wixStyles.colors.calendarBackgroundColorWithoutOpacity.value
            : 'white',
        cellBorderColor: typeof wixStyles.colors.cellBorderColor !== 'undefined'
            ? wixStyles.colors.cellBorderColor.value
            : 'lightgray',
        cellBorderWidth: typeof wixStyles.numbers.cellBorderWidth !== 'undefined'
            ? wixStyles.numbers.cellBorderWidth
            : 1,
        todayBorderColor: typeof wixStyles.colors.todayCellColor !== 'undefined'
            ? wixStyles.colors.todayCellColor.value
            : 'rgba(0,87,225,1)',
        isCurrentTimeIndicator: typeof wixStyles.booleans.isCurrentTimeIndicator === 'undefined'
            ? true
            : wixStyles.booleans.isCurrentTimeIndicator,
        currentTimeLineColor: typeof wixStyles.colors.currentTimeLineColor === 'undefined'
            ? 'rgb(237, 88, 41)'
            : wixStyles.colors.currentTimeLineColor.value,
        isCurrentTimeShown: typeof wixStyles.booleans.isCurrentTimeIndicator === 'undefined'
            ? true
            : wixStyles.booleans.isCurrentTimeIndicator,
        is24format: typeof wixStyles.numbers.timeFormatWeekly === 'undefined'
            ? true
            : wixStyles.numbers.timeFormatWeekly === 24,
        isResponsive: typeof wixStyles.numbers.calendarHeightWeekly === 'undefined'
            ? true
            : wixStyles.numbers.calendarHeightWeekly === 0,
        isGoogleColor: wixStyles.numbers.siteOrGoogleCalendarColors || 0,
        googleCalendarColors: typeof wixStyles.numbers.siteOrGoogleCalendarColors === 'undefined'
            ? false
            : wixStyles.numbers.siteOrGoogleCalendarColors === 1,
        isTimeShown: typeof wixStyles.booleans.isTimeShown === 'undefined'
            ? true
            : wixStyles.booleans.isTimeShown,
        timezoneFontSize: typeof wixStyles !== 'undefined' &&
            typeof wixStyles.fonts.headerFont !== 'undefined'
            ? wixStyles.fonts.headerFont.size
            : 16,
        isWeekFontMoreTwantyFive: typeof wixStyles !== 'undefined' &&
            typeof wixStyles.fonts.weekFont !== 'undefined' &&
            wixStyles.fonts.headerFont.size >= 25,
        isWeekFontMoreTwanty: typeof wixStyles !== 'undefined' &&
            typeof wixStyles.fonts.weekFont !== 'undefined' &&
            wixStyles.fonts.weekFont.size >= 20,
        isCalendarsFontMoreTwanty: typeof wixStyles !== 'undefined' &&
            typeof wixStyles.fonts.calendarsFont !== 'undefined' &&
            wixStyles.fonts.calendarsFont.size >= 20,
        isHeaderFontMoreTwanty: typeof wixStyles !== 'undefined' &&
            typeof wixStyles.fonts.headerFont !== 'undefined' &&
            wixStyles.fonts.headerFont.size >= 20,
        fontMoreTwantySeven: (typeof wixStyles !== 'undefined' &&
            typeof wixStyles.fonts.weekFont !== 'undefined' &&
            wixStyles.fonts.weekFont.size >= 27) ||
            window.innerWidth < 600,
        indicatorWidth: typeof wixStyles.numbers.eventTimeIndicatorWidth !== 'undefined'
            ? wixStyles.numbers.eventTimeIndicatorWidth
            : 2,
        isLeft: typeof wixStyles.numbers.calendarAlignmentWeekly === 'undefined'
            ? false
            : wixStyles.numbers.calendarAlignmentWeekly === 0,
        mobile_weeklyHoursFontSize: typeof wixStyles.numbers.mobile_weeklyHoursFontSize === 'undefined'
            ? 12
            : wixStyles.numbers.mobile_weeklyHoursFontSize,
        todayBtnStyles: typeof wixStyles.numbers.todayBtnStyles === 'undefined'
            ? 1
            : wixStyles.numbers.todayBtnStyles,
    };
}
//# sourceMappingURL=getWixStylesContextData.js.map